import { useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';

import * as actions from './store/actions';
import DataTable from '../core/components/datatable/DataTable';
import useComponentDidMount from '../core/hooks/useComponentDidMount';

// interface InsuranceLossesProps {
//   getClientInsuranceLosses?(...args: unknown[]): unknown
//   insuranceLosses?: unknown[]
//   clientId?: string
// }

const InsuranceLosses = props => {
  const {
    getClientInsuranceLosses,
    insuranceLosses,
    clientId,
  } = props;

  const columns = [
    { name: 'carmenLeadId', title: 'ID лида в Carmen', width: 150 },
    { name: 'maId', title: 'Номер заявки партнёра', width: 150 },
    { name: 'description', title: 'Описание', width: 'auto' },
    {
      name: 'updateDateUtc',
      title: 'Время обновления',
      getCellValue: (row, cell) => moment(row[cell]).format('DD.MM.YYYY HH:mm'),
      width: 200,
    },
  ];

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    await getClientInsuranceLosses(clientId);
    setLoading(false);
  };

  useComponentDidMount(() => {
    loadData();
  });

  return (
    <Col md={ 12 }>
      <Row>
        <Col md={ 12 }>
          <h4 className='mb-4'>Убытки клиента</h4>
          <DataTable
            loading={ loading }
            data={ insuranceLosses }
            columns={ columns }
            columnsResizingMode='nextColumn'
            localSorting
            localPaging
            hideToolbar
          />
        </Col>
      </Row>
    </Col>
  );
};

const mapStateToProps = state => ({
  insuranceLosses: state.clients.insuranceLosses,
});

const mapDispatchToProps = {
  getClientInsuranceLosses: actions.getClientInsuranceLosses,
};

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceLosses);
